import { Marker, Popup } from 'react-leaflet';
import useZoomLevel from './useZoomLevel';
import { CONST_CANTON, CONST_HIGHWAY, iconProblem } from '../Constants/ConstantsOptics';
import { DELETE_PROBLEM_LINE_ID_API_URL, UPDATE_PROBLEM_LINE_COMMENT_API_URL } from '../OpticApiConfig';
import { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import axios from 'axios';

  const MarkersViewingProblemCable = ({ data, isLineDrawing, user, cantonCablaRefresh,setMarkerProblemLineCoordinates, mapRef,
    statusModalTerritory, highwayRefresh }) => {

    const token = localStorage.getItem('token');
    const map = mapRef.current;
    const zoomLevel = useZoomLevel();
    const [editStates, setEditStates] = useState({});
    const [descriptions, setDescriptions] = useState({});

  const toggleEdit = (id, currentText) => {
    setEditStates(prev => ({ ...prev, [id]: !prev[id] }));
    if (!editStates[id]) {
      setDescriptions(prev => ({ ...prev, [id]: currentText }));
    }
  };

  const handleInputChange = (id, value) => {
    setDescriptions(prev => ({ ...prev, [id]: value }));
  };

  const handleSave = (id, originalText) => {
    const newText = descriptions[id];

    if (newText !== originalText) {
      UpdateComment(id, newText, user);
    } else {
    }
    setEditStates(prev => ({ ...prev, [id]: false }));
  };


     const deleteProblem = async (id) => {
      
              if (!token) {
                  //showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
                  return;
              }
    
              try {
                  let apiProblem = `${DELETE_PROBLEM_LINE_ID_API_URL}?problemId=${id}`;
    
                  const response = await fetch(apiProblem, { 
                      method: 'DELETE',
                      headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}` 
                      }
                  });
      
                  if (response.ok) {
                    //  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                      if (window.currentMarker) {
                        map.removeLayer(window.currentMarker);
                        window.currentMarker = null;
                    }
                      setMarkerProblemLineCoordinates(null);
                      if(statusModalTerritory === CONST_CANTON){
                        cantonCablaRefresh();
                      } else if(statusModalTerritory === CONST_HIGHWAY){
                        highwayRefresh();
                      }
                      
                  } else {
                     // showSnackbar('Ошибка удаления!', 'snackbarWarning');
                  }
              } catch (error) {
                //  showSnackbar('Произошла ошибка!', 'snackbarWarning');
              }  
          };

  const UpdateComment = (id, textComment, authorId) => {
    if (!token) {
        return;
    }
    axios.patch(`${UPDATE_PROBLEM_LINE_COMMENT_API_URL}${id}`, { comment: textComment, authorId: authorId }, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        }
    })
    .then(response => {
       setMarkerProblemLineCoordinates(null);
        if(statusModalTerritory === CONST_CANTON){
          cantonCablaRefresh();
        } else if(statusModalTerritory === CONST_HIGHWAY){
          highwayRefresh();
        }
    })
    .catch(error => {
        console.log(error)
    });
};

          
    return (
      <>
        {data.map((item, index) => {
          const eventHandlers = {};
          if (!isLineDrawing) {
            eventHandlers.click = () => {
            
          };
        }

          if (zoomLevel <= 16) {
            return null;
          }

          return (
            <Marker
              key={index}
              position={[item.latitude, item.longitude]}
              icon={iconProblem}
            >
            <Popup className="custom-popup">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                
                <img 
                  src="./problem.png" 
                  width="40" 
                  height="40" 
                  style={{ marginBottom: "5px" }} 
                  alt="pr"
                />
              </div>
              <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
                ID: <span style={{ color: 'black', fontWeight: 'normal' }}> {item.id}</span>
              </span>
              <br/>
              <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
                Тип: <span style={{ color: 'black', fontWeight: 'normal' }}> {item.problemType}</span>
              </span>
              <hr className='horizontalLineFilter' />

             <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#616161' }}>
            Коммент:
          </span>
          {editStates[item.id] ? (
             <textarea
                className='textAreaEditingModal'
                value={descriptions[item.id]}
                onChange={(e) => handleInputChange(item.id, e.target.value)}
                style={{width: "200px", height: "100px", fontSize: '13px' }}
            />
           
          ) : (
            <span style={{ color: 'black', fontWeight: 'normal', fontSize: '13px' }}>
              {item.description}
            </span>
          )}
        {user === item.authorId && (
          editStates[item.id] ? (
                        <SaveIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSave(item.id, item.description);
                          }}
                          style={{ color: 'green', cursor: 'pointer', fontSize: 18 }}
                        />
                      ) : (
                        <EditIcon
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleEdit(item.id, item.description);
                          }}
                          style={{ color: 'red', cursor: 'pointer', fontSize: 18 }}
                        />
                      )
        )}
              
        </div>
     
              {/* <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#616161' }}>Коммент:
              </span><span style={{ color: 'black', fontWeight: 'normal', fontSize: '13px' }}> {item.description} </span> <br />
               <button  onClick={() => deleteProblem(item.id)}  className="buttonIsDeleteModal2" style={{ marginLeft: "0px",fontSize: '10px' }}>
                  Редактировать
                </button>
                 <button  onClick={() => deleteProblem(item.id)}  className="buttonIsDeleteModal2" style={{ marginLeft: "0px",fontSize: '10px' }}>
                  Сохранить
                </button> */}
              <hr className='horizontalLineFilter' />
              <br/>
              {user === item.authorId && (
                <button  onClick={() => deleteProblem(item.id)}  className="buttonIsDeleteModal2" style={{ marginLeft: "0px",fontSize: '10px' }}>
                  Удалить
                </button>
              )}
            </Popup>
          </Marker>

          );
        })}
      </>
    );
  };
  
  export default MarkersViewingProblemCable;